module.exports = __webpack_public_path__ + "img/uturn-right.7263241a.svg";